module.exports = __webpack_public_path__ + "static/media/cloud-showers.0f81bd8b.svg";